import React from "react";

import { CardContainer, CardHeading, CardParagraph } from "./styles";
import EditableText from "../../inline-edit/EditableText";
import { CARDS_PROP } from "../../../../../../settings/features/cards/defaults";

const ImageFive = ({ data, config, isEditable }) => {
  return (
    <CardContainer
      imageUrl={data.image.link}
      position={data.image.focalPoint}
      borderRadius={config.borderRadius}
    >
      <CardHeading>
        {isEditable ? (
          <EditableText
            data={data}
            config={config}
            inputProp={CARDS_PROP.TITLE}
            customCalculatorStyles={{ minHeight: "1em" }}
          />
        ) : (
          data.title
        )}
      </CardHeading>
      {config.layout.includes(CARDS_PROP.TEXT) && (
        <CardParagraph>
          {isEditable ? (
            <EditableText
              data={data}
              config={config}
              inputProp={CARDS_PROP.TEXT}
            />
          ) : (
            data.text
          )}
        </CardParagraph>
      )}
    </CardContainer>
  );
};

export default ImageFive;
